import React from "react";
import { useTranslation } from "react-i18next";
import { Receipt } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { isNative } from "../lib/native";

// Official customer portals. Never include account IDs or purchase proofs in URLs.
export const PURCHASE_HELP = {
  apple: {
    name: "Apple",
    refund: "https://reportaproblem.apple.com/",
    history: "https://reportaproblem.apple.com/",
  },
  google: {
    name: "Google Play",
    refund: "https://support.google.com/googleplay/workflow/9813244",
    history: "https://play.google.com/store/account/orderhistory",
  },
};

export default function StorePurchaseHelp() {
  const { t } = useTranslation();
  const { user, subscription } = useAuth();
  const recorded = new Set([
    ...(subscription?.subscriptions || []).map((s) => s.provider),
    subscription?.provider, user?.iap_provider,
  ]);
  const known = Object.keys(PURCHASE_HELP).filter((provider) => recorded.has(provider));
  // An unknown store must be chosen by the customer, never inferred from the device.
  const providers = known.length ? known : Object.keys(PURCHASE_HELP);
  // Capacitor sends external main-frame navigations to the system browser.
  const target = isNative() ? "_self" : "_blank";

  return <>
    {["refund", "history"].map((kind) => <section key={kind} className="hm-card p-5 mt-4"
      aria-labelledby={`purchase-help-${kind}`} data-testid={`account-${kind === "refund" ? "refund" : "billing"}-section`}>
      <h2 id={`purchase-help-${kind}`} className="flex items-center gap-2 text-sm font-bold uppercase tracking-[0.15em] text-white/60 mb-4">
        <Receipt size={17} weight="bold" color="#D4AF37" /> {t(`purchaseHelp.${kind}Title`)}
      </h2>
      <p className="text-sm text-white/50 mb-3">{t(`purchaseHelp.${kind}Description`)}</p>
      {!known.length && <p className="text-sm text-white/50 mb-3">{t("purchaseHelp.chooseStore")}</p>}
      <div className="space-y-2">
        {providers.map((provider) => <a key={provider} href={PURCHASE_HELP[provider][kind]}
          target={target} rel="noopener noreferrer" data-testid={`purchase-${kind}-${provider}`}
          className="flex items-center justify-center min-h-11 px-3 py-3 rounded-xl bg-white/10 border border-white/15 text-white text-center font-bold text-sm hover:bg-white/15">
          {t(`purchaseHelp.${kind}Link`, { store: PURCHASE_HELP[provider].name })}
        </a>)}
      </div>
      <p className="text-xs text-white/40 mt-3">{t("purchaseHelp.signIn")}</p>
    </section>)}
  </>;
}
